module.exports = __webpack_public_path__ + "static/media/prepaid_recharge.068e942f.svg";